import styled from "styled-components";
import BaseTextArea from "../ui/TextArea";

interface SectionBoxProps {
  $empty?: boolean;
}

export const StyledTextArea = styled(BaseTextArea)`
  height: 40px;
  padding: 6px 4px;
  border: none;
  border-radius: 0;
  resize: none;
  line-height: 1.4;
  background: transparent;

  &:focus {
    border-color: ${({ theme }) => theme.THEME.neonBlue};
  }
`;

export const SectionBox = styled.div<SectionBoxProps>`
  width: 85%;
  border: 1px solid ${({ theme }) => theme.THEME.neonBlue};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  background: ${({ $empty }) =>
    $empty ? "rgba(0, 6, 22, 0.6)" : "rgba(0, 6, 22, 0.6)"};
  opacity: ${({ $empty }) => ($empty ? 0.4 : 1)};
  position: relative;
`;

export const SectionTitle = styled.h2`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  font-family: "Sora", sans-serif;
  margin-bottom: 12px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.THEME.grayText};
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  font-size: 16px;
  padding: 6px 4px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.THEME.neonBlue};
  }
`;

export const ImagePreview = styled.img`
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
  max-height: 200px;
`;

export const EmptyState = styled.p`
  color: ${({ theme }) => theme.THEME.grayText};
  font-style: italic;
`;

export const IconGroup = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 12px;

  svg {
    cursor: pointer;
    color: ${({ theme }) => theme.THEME.neonBlue};
    transition: 0.2s;

    &:hover {
      color: ${({ theme }) => theme.THEME.white};
    }
  }
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
    transition: 0.2s ease-in-out;

    &:hover {
      filter: brightness(1.5);
    }
  }
`;

export const InlineToast = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 10000;
  background: rgba(0, 217, 255, 0.12);
  border: 1px solid ${({ theme }) => theme.THEME.neonBlue};
  color: ${({ theme }) => theme.THEME.white};
  backdrop-filter: blur(6px);
  padding: 10px 14px;
  border-radius: 12px;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 20}px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 4.8}px;
  }
`;
